//roles and permissions
export const ROLES = '/roles';
export const PERMISSIONS = '/permissions';
export const DEFAULT_PERMISSIONS = '/default-permissions';

//public (but, should be logged in)
export const PUBLIC_ROLES = '/public/roles';

//import
export const FILE_UPLOAD_URL = "/import/{company_uuid}/upload/{session_id}"; //+session_id is automatically added
export const FILE_CANCEL_URL = "/import/{company_uuid}/cancel-upload"; //+session_id is automatically added;
export const RECENTLY_UPLOADED_FILES  = "/import/{company_uuid}/recently-uploaded-files";
export const RECENTLY_UPLOADED_ZIP_FILES  = "/import/{company_uuid}/recently-uploaded-zip-files";

//works
export const WORKS = "/works";
export const WORK_DATE_INTERVAL_UNIT_PRICES = "/works/{work_uuid}/date-interval-unit-prices";
export const WORK_MAIN_GROUPS = "/work-main-groups";
export const PARCELS = "/parcels";
export const CHANGE_PARCELS_CULTURE = "/parcels/change/culture";
export const CHANGE_PARCELS_GROUP = "/parcels/change/group";
export const PARCELS_COPY = "/parcels/copy";
export const PARCELS_CROP_ROTATION = "/parcels/crop-rotation";
export const PARCELS_HARVESTED_SURFACE = "/parcels/harvested-surface";
export const PARCELS_SOWED_SURFACE = "/parcels/sowed-surface";
export const PERSONS = "/persons";
export const EMPLOYEE_GROUPS = "/employee-groups";
export const WORK_MACHINES = "/work-machines";
export const WORK_MACHINE_EXPIRATION_DOCUMENT_TYPES = "/work-machines/expiration-document-types";
export const WORK_MACHINE_EQUIPMENTS = "/work-machine-equipments";
export const WORK_MACHINE_COSTS = "/work-machine-costs";
export const WORK_MACHINE_COST_TYPES = "/work-machine-costs/types";
export const WORK_MACHINE_COSTS_COMBINED = "/work-machine-costs/combined";
export const CULTURES = "/cultures";
export const FITO_CULTURES = "/fito-cultures";
export const CULTURE_GROUPS = '/mobile/culture-groups';
export const CULTURE_VARIETIES = "/culture-varieties";
export const BBCHS = "/fito-culture-bbch-values";
export const WORKS_HAS_WORK_MACHINES = "/works-has-work-machines";

//seasons
export const SEASONS = "/seasons";
export const SEASONS_FILTER = "/seasons/filters";

//layers
export const LAYERS = "/layers";
export const LAYERS_COST_STRATIFICATION = "/layers/cost-stratification";
export const PREVIEW_PARCEL_NAME = "/preview-parcel-name";

//season on parcel has culture
export const SEASON_ON_PARCEL_HAS_CULTURE = "/season-on-parcel-has-culture";
export const SEASON_ON_PARCEL_HAS_CULTURE_BULK = "/season-on-parcel-has-culture/bulk";
export const SPC_WORK_DETAILS = "/work-details";

// work approval
export const WORK_APPROVAL_WORKS       = "/work-approval/works";
export const WORK_APPROVAL_PRODUCTIONS = "/work-approval/productions";
export const WORK_APPROVAL_WORKS_DOCUMENT_GENERATION_STATUSES = "/work-approval/works/document-generation-statuses";
export const WORK_APPROVAL_PRODUCTIONS_DOCUMENT_GENERATION_STATUSES = "/work-approval/productions/document-generation-statuses";
export const WORK_APPROVAL_WORKS_APPROVE      = "/work-approval/works/approve";
export const WORK_APPROVAL_WORKS_REVOKE       = "/work-approval/works/revoke";
export const WORK_APPROVAL_PRODUCTIONS_APPROVE = "/work-approval/productions/approve";
export const WORK_APPROVAL_PRODUCTIONS_REVOKE  = "/work-approval/productions/revoke";

export const PARCEL_MANAGEMENT_MOVABLE_DATA = "/parcel-management/movable-data";
export const PARCEL_MANAGEMENT_EXECUTE = "/parcel-management/execute";

//mobile spc works
export const MOBILE_SPC_WORKS = "/mobile/spc/works"
export const MOBILE_SPC_WORK_FILTERS = "/mobile/spc/work/filters"
export const MOBILE_SPC_WORK_SUMMARY = "/mobile/spc/work-summary"

//mobile spc machines
export const MOBILE_SPC_MACHINES = "/mobile/work-machines"
export const MOBILE_SPC_MACHINES_FILTER = "/mobile/work-machines/filter"

//mobile spc parcels
export const MOBILE_SPC_PARCELS = "/mobile/parcels"
export const MOBILE_SPC_PARCEL_FOR_FILTERS = "/mobile/parcel/filters"

//fito products
export const FITO_PRODUCTS = "/fito/products";
export const FITO_PRODUCTS_LIGHT = "/mobile/fito-products";
export const FITO_MEASURE_UNITS = "/fito/measure-units";

//fertility products
export const FERTILITY_PRODUCTS = "/fertility-products";
export const FERTILITY_PRODUCTS_LIGHT = "/mobile/fertility-products";
export const FERTILITY_MEASURE_UNITS = "/fertility/measure-units/search";

//product-suggestions
export const PRODUCT_SUGGESTIONS = "/product-suggestions";

//batch
export const BATCH = "/batch";
export const BATCH_USED_PRODUCTS = "/batch/getUsedProducts";
export const BATCH_HEADER_SUMMARY = "/batch/getSummary";
export const BATCH_MEASURE_UNITS = "/batch-measure-units";
export const CREATE_BATCH = "/batch";

//batch-header
export const BATCH_HEADERS = "/batch-headers";
export const DELETE_BATCH_HEADERS = "/batch/{batch_uuid}/headers/{header_uuid}";

//salary calculator
export const SC_BONUS = "/sc/bonuses";
export const SC_BONUS_TYPES = "/sc/bonus-types";
export const SC_BONUS_CALCULATION_TYPES = "/sc/bonus-calculation-types";
export const SC_HOLIDAY = "/sc/holidays";
export const SC_EMPLOYEE = "/sc/employees";
export const SC_EMPLOYEE_ROLE = "/sc/employee-roles";
export const SC_MEASURE_UNIT = "/sc/measure-units";
export const SC_SHIFT = "/sc/shifts";
export const SC_WORK = "/sc/works";
export const SC_WORK_COLLECTOR = "/sc/work-collector";
export const SC_WORK_GROUP = "/sc/work-groups";
export const SC_WORK_PIVOT = "/sc/work-pivots";
export const SC_WORK_COLLECTOR_HECTARE_DATA = "/sc/work-logs-hectare-data";
export const SC_WORK_HIERARCHY = "/sc/work-hierarchy";
export const SC_WORK_LOG = "/sc/work-logs";///sc/work-logs/employees/{employee_uuid}
export const SC_WORK_LOG_EXPORT_EXCEL = "/sc/export/work-logs/excel";
export const SC_WORK_LOG_CLEANUP_OVERLAPS = "/sc/work-logs/cleanup-overlaps";
export const SC_WORK_LOG_EMPLOYEE_EXPORT_EXCEL = "/sc/export/employee-works/excel";
export const SC_DOWNLOAD_DAILY_REPORT = "/sc/reports/daily-report";
export const SC_DOWNLOAD_SHR_REPORT = "/sc/reports/shr-report"; // not in use

//file actions
export const CSV_HEADERS = "/file-service/csv-headers";
export const CSV_HEADERS_QUERY = "/file-service/csv-headers-query";
export const RETRY_CSV_IMPORT = "/file-service/retry-csv-import";

//import config
export const IMPORT_CONFIG_TEMPLATE = "/import-config/template";
export const IMPORT_CONFIG_TEMPLATES = "/import-config/templates";
export const IMPORT_CONFIG_REQUIRED_ATTRIBUTES = "/import-config/required-attributes";
export const IMPORT_CONFIG_CONFIGURATIONS = "/import-config/configurations";
export const IMPORT_CONFIG_SOURCE_CREDENTIALS = "/import-config/source-credentials";
export const IMPORT_CONFIG_VALIDATED_DATA = "/import-config/validated-data";
export const IMPORT_CONFIG_VALIDATED_DATA_SETTINGS = "/import-config/validated-data-settings";
export const IMPORT_CONFIG_VALIDATED_DATA_LIVE_DATA = "/import-config/validated-data-live-data";
export const IMPORT_CONFIG_IMPORT_DATA_API_CALL = "/import/import-data-api-call";
export const TRACKTOR_API_GET_PROJECTS = "/tracktor-api/get-projects";
export const TRACKTOR_API_SYNC_PROJECTS = "/tracktor-api/sync-projects";
export const TRACKTOR_API_SYNC_CROPS = "/tracktor-api/sync-crops";
export const TRACKTOR_API_GET_VEHICLES = "/tracktor-api/get-vehicles";
export const TRACKTOR_API_SYNC_VEHICLES = "/tracktor-api/sync-vehicles";
export const TRACKTOR_API_GET_SYNC_STATUS = "/tracktor-api/sync-status";

//settings
export const SETTING_GROUPS = "/setting-groups";
export const GROUP_SETTINGS = "/settings/by-uuid/{uuid}";
export const GROUP_SETTINGS_UPDATE = "/settings/{uuid}";
export const GROUP_SETTING = "/settings/{uuid}/{code}";
export const GROUP_BY_CODE = "/settings/{code}";
export const SETTING_BY_CODE = "/company-settings/{group_code}/{item_code}";
export const SETTINGS_FOR_GENERAL_USAGE = "/setting-groups/for-general-usage";
export const SETTINGS_BASE_URL = "/settings/baseurl";

//custom products
export const CUSTOM_PRODUCT = "/custom-products";

//custom product statuses
export const CUSTOM_PRODUCT_STATUS = "/mobile/custom-product-status-types";

//stock management
export const SM_PARTNERS = "/stock-management/partners";
export const SM_PARTNER_TYPES = "/stock-management/partner-types";
export const SM_PARTNER_LEGAL_FORMS = "/stock-management/partner-legal-forms";
export const SM_WAREHOUSES = "/stock-management/warehouses";
export const SM_PRODUCTS = "/stock-management/products";
export const SM_PRODUCT_DATE_INTERVAL_UNIT_PRICES = "/stock-management/products/{product_uuid}/date-interval-unit-prices";
export const SM_PRODUCT_TYPES = "/stock-management/product-types"
export const SM_PRODUCT_TYPE_SEARCH = "/stock-management/product-type-search"
export const SM_STOCKS = "/stock-management/warehouse-stock"
export const SM_STOCK_PRODUCT_INFO = "/stock-management/warehouse-stock/products"
export const SM_STOCK_PRODUCT_HISTORY = "/stock-management/warehouse-stock-products"
export const SM_PRODUCT_MEASURE_UNITS = "/stock-management/products/measure-units";
export const SM_PRODUCT_VAT_LIST = "/stock-management/vat-list";

export const SM_RECEPTION_TRANSACTION = "/stock-management/transactions/reception";
export const SM_PRODUCTION_TRANSACTION = "/stock-management/transactions/production";
export const SM_PRODUCTION_TRANSACTION_PRE_DIVIDED = "/stock-management/transactions/production/pre-divided";
export const SM_RECEPTION_CHECK_SHIPPING_NUMBER = "/stock-management/transactions/reception/check-shipping-number";
export const SM_SALES_TRANSACTION = "/stock-management/transactions/sales";
export const SM_CONSUM_TRANSACTION = "/stock-management/transactions/consum";
export const SM_MACHINE_CONSUM_TRANSACTION = "/stock-management/transactions/machine-consume";
export const SM_MACHINE_CONSUM_HISTORY = "/stock-management/transactions/machine-consume";
export const SM_TRANSFER_TRANSACTION = "/stock-management/transactions/transfer";
export const SM_REQUALIFICATION_TRANSACTION = "/stock-management/transactions/requalification";
export const SM_STORAGE_LOSSES = "/stock-management/storage-losses";

// contract purchase sale
export const SM_CONTRACTS_PURCHASE_SALE = "/stock-management/contracts-purchase-sale";
export const SM_CONTRACTS_PURCHASE_SALE_DETAILS = "/stock-management/contracts-purchase-sale/details";
export const SM_CONTRACTS_PURCHASE_SALE_TYPES = "/stock-management/contracts-purchase-sale/types";

// orders
export const SM_ORDERS = "/stock-management/orders";
export const SM_ORDERS_DETAILS = "/stock-management/orders/details";
export const SM_ORDERS_TYPES = "/stock-management/orders/types";

// invoice management
export const SM_INVOICE_MANAGEMENT = "/stock-management/invoice-management";

// predefined lot numbers
export const SM_PREDEFINED_LOT_NUMBERS = "/stock-management/predefined-lot-numbers";

// label management
export const LABELS = "/tools/labels";
export const AI_CHAT_SETTINGS = "/ai-chat/settings";
export const AI_CHAT_CACHE_RESET = "/ai-chat/cache/reset";
export const AI_CHAT_OPENROUTER_MODELS = "/ai-chat/openrouter-models";
export const AI_CHAT_TOOL_SEARCH = "/ai-chat/tools/search";
export const AI_CHAT_KNOWLEDGE = "/ai-chat/knowledge";
export const AI_CHAT_COMPLETIONS = "/ai-chat/completions";
export const AI_CHAT_COMPLETION_STATUS = "/ai-chat/completions";
// OpenRouter Responses API - required by the openrouter:tool_search server tool.
export const AI_CHAT_RESPONSES = "/ai-chat/responses";
export const AI_CHAT_HISTORY_SESSIONS = "/ai-chat/history/sessions";
export const AI_CHAT_CONTEXT_COMPACTION = "/ai-chat/history/sessions";

//nomenclator
export const MEASURE_UNITS = "/measure-units";

//Legacy ERP bridge endpoints
export const ERP_LEGACY_SYNC_MEASURE_UNITS = "/erp/legacy/measure-units/sync";
export const ERP_LEGACY_MEASURE_UNITS = "/erp/legacy/measure-units";
export const ERP_LEGACY_MEASURE_UNIT_MAPPINGS = "/erp/legacy/measure-unit-mappings";
export const ERP_LEGACY_SYNC_PRODUCT_TYPES = "/erp/legacy/product-types/sync";
export const ERP_LEGACY_PRODUCT_TYPES = "/erp/legacy/product-types";
export const ERP_LEGACY_PRODUCT_TYPE_MAPPINGS = "/erp/legacy/product-type-mappings";
export const ERP_LEGACY_SYNC_WAREHOUSES = "/erp/legacy/warehouses/sync";
export const ERP_LEGACY_WAREHOUSES = "/erp/legacy/warehouses";
export const ERP_LEGACY_WAREHOUSE_MAPPINGS = "/erp/legacy/warehouse-mappings";
export const ERP_LEGACY_SYNC_LEGAL_ENTITIES = "/erp/legacy/legal-entities/sync";
export const ERP_LEGACY_LEGAL_ENTITIES = "/erp/legacy/legal-entities";
export const ERP_LEGACY_LEGAL_ENTITY_MAPPINGS = "/erp/legacy/legal-entity-mappings";
export const ERP_LEGACY_RECEPTIONS_EXPORT = "/erp/legacy/receptions/export";
export const ERP_LEGACY_RECEPTIONS_PREVIEW = "/erp/legacy/receptions/preview";
export const ERP_LEGACY_RECEPTIONS_QUEUE = "/erp/legacy/receptions/queue";
export const ERP_LEGACY_RECEPTIONS_QUEUE_ITEM = "/erp/legacy/receptions/queue/{uuid}";
export const ERP_LEGACY_RECEPTIONS_QUEUE_VALIDATE = "/erp/legacy/receptions/queue/{uuid}/validate";
export const ERP_LEGACY_RECEPTIONS_QUEUE_SEND = "/erp/legacy/receptions/queue/{uuid}/send";
export const ERP_LEGACY_RECEPTIONS_QUEUE_RETRY = "/erp/legacy/receptions/queue/{uuid}/retry";
export const ERP_LEGACY_RECEPTIONS_QUEUE_CANCEL = "/erp/legacy/receptions/queue/{uuid}/cancel";
export const ERP_LEGACY_RECEPTIONS_BULK_RETRY = "/erp/legacy/receptions/bulk-retry";
export const ERP_LEGACY_RECEPTIONS_MAPPINGS = "/erp/legacy/receptions/mappings";
export const ERP_LEGACY_RECEPTIONS_SETTINGS = "/erp/legacy/receptions/settings";
export const ERP_LEGACY_TRANSFERS_EXPORT = "/erp/legacy/transfers/export";
export const ERP_LEGACY_TRANSFERS_PREVIEW = "/erp/legacy/transfers/preview";
export const ERP_LEGACY_TRANSFERS_QUEUE = "/erp/legacy/transfers/queue";
export const ERP_LEGACY_TRANSFERS_QUEUE_ITEM = "/erp/legacy/transfers/queue/{uuid}";
export const ERP_LEGACY_TRANSFERS_QUEUE_VALIDATE = "/erp/legacy/transfers/queue/{uuid}/validate";
export const ERP_LEGACY_TRANSFERS_QUEUE_SEND = "/erp/legacy/transfers/queue/{uuid}/send";
export const ERP_LEGACY_TRANSFERS_QUEUE_RETRY = "/erp/legacy/transfers/queue/{uuid}/retry";
export const ERP_LEGACY_TRANSFERS_QUEUE_CANCEL = "/erp/legacy/transfers/queue/{uuid}/cancel";
export const ERP_LEGACY_TRANSFERS_BULK_RETRY = "/erp/legacy/transfers/bulk-retry";
export const ERP_LEGACY_TRANSFERS_MAPPINGS = "/erp/legacy/transfers/mappings";
export const ERP_LEGACY_TRANSFERS_SETTINGS = "/erp/legacy/transfers/settings";
export const ERP_LEGACY_APPROVED_CONSUMS = "/erp/legacy/consums/approved";
export const ERP_LEGACY_APPROVED_CONSUM_BATCHES = "/erp/legacy/consums/approved-batches";
export const ERP_LEGACY_APPROVED_CONSUM_BATCH = "/erp/legacy/consums/approved-batches/{uuid}";
export const ERP_LEGACY_CONSUMS_VALIDATE = "/erp/legacy/consums/validate";
export const ERP_LEGACY_CONSUMS_EXPORT = "/erp/legacy/consums/export";
export const ERP_LEGACY_CONSUMS_INVOICE_RETRY = "/erp/legacy/consums/invoices/{uuid}/retry";
export const ERP_LEGACY_CONSUMS_INVOICE = "/erp/legacy/consums/invoices/{uuid}";
export const ERP_LEGACY_CONSUMS_WORK_INVOICES = "/erp/legacy/consums/work-invoices";
export const ERP_LEGACY_CONSUMS_QUEUE = "/erp/legacy/consums/queue";
export const ERP_LEGACY_CONSUMS_QUEUE_ITEM = "/erp/legacy/consums/queue/{uuid}";
export const ERP_LEGACY_CONSUMS_QUEUE_VALIDATE = "/erp/legacy/consums/queue/{uuid}/validate";
export const ERP_LEGACY_CONSUMS_QUEUE_SEND = "/erp/legacy/consums/queue/{uuid}/send";
export const ERP_LEGACY_CONSUMS_QUEUE_RETRY = "/erp/legacy/consums/queue/{uuid}/retry";
export const ERP_LEGACY_CONSUMS_QUEUE_CANCEL = "/erp/legacy/consums/queue/{uuid}/cancel";
export const ERP_LEGACY_CONSUMS_BULK_RETRY = "/erp/legacy/consums/bulk-retry";
export const ERP_LEGACY_CONSUMS_BULK_CANCEL = "/erp/legacy/consums/bulk-cancel";

//Generic ERP integration
export const ERP_ENTITIES = "/erp/entities";
export const ERP_ENTITY_BY_CODE = "/erp/entities/{entityCode}";
export const ERP_ENTITY_DETECT_SCHEMA = "/erp/entities/{entityCode}/detect-schema";
export const ERP_ENTITY_SYNC = "/erp/entities/{entityCode}/sync";
export const ERP_ENTITY_RECORDS = "/erp/entities/{entityCode}/records";
export const ERP_ENTITY_SOURCE_ROWS = "/erp/entities/{entityCode}/source-rows";
export const ERP_ENTITY_AUTO_MATCH = "/erp/entities/{entityCode}/auto-match";
export const ERP_ENTITY_STATIC_MAPPINGS = "/erp/entities/{entityCode}/static-mappings";
export const ERP_ENTITY_STATIC_MAPPING_BY_ID = "/erp/entities/{entityCode}/static-mappings/{id}";
export const ERP_ENTITY_PARCEL_MAPPINGS = "/erp/entities/{entityCode}/parcel-mappings";
export const ERP_ENTITY_PARCEL_MAPPING_BY_ID = "/erp/entities/{entityCode}/parcel-mappings/{id}";
export const ERP_SYNC_LOGS = "/erp/sync-logs";
export const ERP_SYNC_LOG_BY_UUID = "/erp/sync-logs/{uuid}";
export const ERP_SYNC_LOG_CANCEL = "/erp/sync-logs/{uuid}/cancel";
export const ERP_ENTITY_CLEAN_PREVIEW = "/erp/entities/{entityCode}/clean/preview";
export const ERP_ENTITY_CLEAN_APPLY = "/erp/entities/{entityCode}/clean/apply";
export const ADDRESS_COUNTIES = "/address/counties";
export const ADDRESS_COUNTRIES = "/address/countries";
export const ADDRESS_LOCALITIES = "/address/localities";

export const PARCEL_CONSUM = "/stock-management/transactions/parcel-consums";
export const PARCEL_CONSUM_SUMMARY = "/stock-management/transactions/parcel-consum-summary";
export const PARCEL_PRODUCTION = "/stock-management/transactions/parcel-productions";
export const PARCEL_PRODUCTION_SUMMARY = "/stock-management/transactions/parcel-production-summary";
export const CONSUM_SUMMARY = "/stock-management/transactions/consum-summary";

export const SM_TRANSACTIONS = "/stock-management/transactions"
export const SM_STOCK_MOVEMENTS = "/stock-management/movements"
export const SM_STOCK_MOVEMENT_ITEMS_AVAILABLE = "/stock-management/stock-movement-items/available"
export const SM_STOCK_MOVEMENT_ITEMS_AVAILABLE_SUM = "/stock-management/stock-movement-items/available-sum"
export const SM_STOCK_MOVEMENT_ITEM_HISTORY = "/stock-management/stock-movement-items"
export const SM_STOCK_MOVEMENT_ITEM_HISTORY_SUM = "/stock-management/stock-movement-items/history-sum"
export const SM_TRANSACTION_TYPES = "/stock-management/transaction-types"
export const SM_STOCK_MOVEMENT_TYPES = "/stock-management/stock-movement-types"
export const SM_TRANSACTIONS_CANCEL = "/stock-management/transactions/cancel"
export const QUANTITY_WARNINGS = "/stock-management/quantity-warnings";
export const QUANTITY_WARNINGS_PRODUCTS = "/stock-management/quantity-warnings/products";
export const QUANTITY_WARNINGS_FULFILLED = "/stock-management/quantity-warnings/fulfilled";

//scale
export const WEIGHING = "/weighing-on-scale";
export const SCALES = "/scales";
export const SCALE_HOUSES = "/scale-houses";
export const SCALE_MEASUREMENT = "/scale-measurement";
export const WEIGHING_ON_SCALE = "/weighing-on-scale";
export const WEIGHING_VEHICLE_CONF = "/weighing-on-scale/vehicle-configurations";
export const WEIGHING_TYPES = "/weighing-on-scale/types";
export const WEIGHING_AUTOCOMPLETE_DATA = "/weighing-on-scale/autocomplete-data";

//lease contracts
export const LEASE_CONTRACTS = "/lease-contract"
export const LEASE_CONTRACT_PRODUCTS = "/lease-contract-product"
export const LEASE_CONTRACT_PRODUCT_PRICE = "/lease-contract-product-price"
export const LEASE_CONTRACT_MU = "/lease-contract-measure-units";
export const AREA_OWNERS_FOR_PAYMENT = "/area-owners-for-payment";
export const LEASE_CONTRACT_CASH_PAYMENT = "/lease-contract-cash-payment";
export const LEASE_CONTRACT_PRODUCT_PAYMENT = "/lease-contract-product-payment";
export const LEASE_CONTRACT_PAYMENT = "lease-contract-payment/lease-contract";
export const LEASE_CONTRACT_PAYMENT_EDIT = "lease-contract-payment-edit";
export const LEASE_CONTRACT_TARIFF_SYSTEM = "/lease-contract-tariff-system";
export const LEASE_CONTRACT_TARIFF_SYSTEM_ITEM = "/lc-tariff-system-item";
export const LC_PAYMENT = "/lc-payment";
export const LC_OWNER = "/lease-contract-owner";
export const LC_OWNER_AND_SURFACE_UPDATE = "/lc-area-surface-owner-update";

//scoutings
export const SCOUTINGS = "/scoutings";
export const SCOUTING = "/scouting";

//tools justifying documents - document blocks
export const DOCUMENT_BLOCKS = "/document-blocks";
export const DOCUMENT_BLOCK_CHECK = "/document-block-check";
export const DOCUMENT_BLOCK_MODEL = "/document-block-model";
export const DOCUMENT_TYPES = "/document-types";
export const IS_DOCUMENT_BLOCK_EXISTS = "/document-block-exists";
export const STATUSES = "/statuses";
export const STATUSES_CRITERIA_COLUMNS = "/statuses/criteria-columns";
export const DXGRID_SETTINGS = "/dxgrid/settings";

//agro filter
export const DEPARTMENT_TYPES = '/department-types';
export const DEPARTMENT_FILTER_TYPES = '/department-filter-types';
export const PARENT_DEPARTMENTS = '/parent-departments';
export const DEPARTMENTS = '/departments';
export const DEPARTMENTS_IMAGE = '/departments/image';

//reports
export const REPORTS = "/reports";
export const REPORT_FILTERS = "/report-filters";
export const REPORT_COLUMNS = "/report-columns";
export const CALL_SP = "/call-sp";

//report groups
export const REPORT_GROUPS = "/report-groups";

// activity logs
export const ACTIVITY_LOGS = "/activity-logs";

// user analytics (company-scoped — endpoints registered in the company subdomain route group)
export const USER_ANALYTICS_USER_ACCESS = "/user-analytics/user-access";
export const USER_ANALYTICS_MODULE_USAGE = "/user-analytics/module-usage";
export const USER_ANALYTICS_MODULE_TREND = "/user-analytics/module-usage-trend";
export const USER_ANALYTICS_USERS_LIST = "/user-analytics/users-list";
export const USER_ANALYTICS_MODULE_USER_LIST = "/user-analytics/module-user-list";
export const USER_ANALYTICS_USER_MODULE_LIST = "/user-analytics/user-module-list";
export const USER_ANALYTICS_USER_TRANSACTIONS = "/user-analytics/user-transactions";

//product catalog
//fito products
export const CATALOG_FITO_PRODUCTS = "/product-catalog/fito-products";
export function replaceParams(url, params = []) {
  let replacedURL = url;
  if (params) {
    Object.keys(params).map((key) => {
      if(params[key]) {
        replacedURL = replacedURL.toString().replace('{'+key+'}', params[key]);
      }
    });
  }

  return replacedURL;
}
